if (!customElements.get('m-request-delivery')) {
  customElements.define(
    'm-request-delivery',
    class MRequestDelivery extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          openButton: '[data-open-request-delivery]',
          content: '.m-form-request-delivery',
          formSuccess: '.form-request-delivery__success',
          skuInput: '[data-rdt-sku]',
          variantInput: '[data-rdt-variant]',
          skuDisplay: '[data-rdt-sku-display]',
          summary: '[data-rdt-summary]',
          messageArea: '[data-rdt-message-default]',
        };
      }

      connectedCallback() {
        this.domNodes = queryDomNodes(this.selectors, this);
        this.colorScheme = this.domNodes.content
          ? this.domNodes.content.dataset.colorScheme
          : '';

        if (this.domNodes.content && this.domNodes.content.innerHTML) {
          this.init();
        }

        this.showSuccessMessage();
      }

      init() {
        this.modal = new MinimogTheme.Modal();

        /* Guard: only bind one document-level listener even when multiple
           m-request-delivery elements exist (e.g. PDP modal + cart drawer modal). */
        if (!window.__rdtDocListenerBound) {
          window.__rdtDocListenerBound = true;
          addEventDelegate({
            context: document,
            selector: this.selectors.openButton,
            handler: (e) => {
              e.preventDefault();
              this.openModal();
            },
          });
        }

        document.addEventListener('variant:changed', (e) => {
          const variant = e.detail && e.detail.variant;
          if (variant) {
            this.updateVariant(variant);
          }
        });
      }

      openModal() {
        const html = document.createElement('div');
        html.innerHTML = this.domNodes.content.innerHTML;
        this.modal.appendChild(html);
        this.modal.setWidth('500px');
        this.modal.setSizes(`m-form-request-delivery m-gradient ${this.colorScheme}`);
        this.modal.open();
      }

      updateVariant(variant) {
        const sku = variant.sku || '';
        const variantTitle = variant.title && variant.title !== 'Default Title'
          ? variant.title
          : '';

        const skuInput = this.querySelector(this.selectors.skuInput);
        const variantInput = this.querySelector(this.selectors.variantInput);
        const skuDisplay = this.querySelector(this.selectors.skuDisplay);
        const messageArea = this.querySelector(this.selectors.messageArea);

        if (skuInput) skuInput.value = sku;
        if (variantInput) variantInput.value = variantTitle;
        if (skuDisplay) skuDisplay.textContent = sku;

        if (messageArea) {
          const defaultMsg = messageArea.dataset.rdtMessageDefault || '';
          const updatedMsg = defaultMsg
            .replace(/SKU[:\s]*[^\s).]*/i, `SKU: ${sku}`)
            .replace(/Art\.-Nr\.[:\s]*[^\s).]*/i, `Art.-Nr.: ${sku}`);
          messageArea.value = updatedMsg;
        }
      }

      showSuccessMessage() {
        const successMessage = this.querySelector(this.selectors.formSuccess);
        if (successMessage) {
          MinimogTheme.Notification.show({
            target: document.body,
            method: 'appendChild',
            type: 'success',
            message: successMessage.dataset.message,
            delay: 2000,
            sticky: true,
          });

          setTimeout(() => {
            const url = window.location.origin + window.location.pathname;
            window.history.replaceState({}, document.title, url);
          }, 2500);
        }
      }
    }
  );
}
